import type { PlaygroundProjectFile } from "../auth/api-client";
import { PlaygroundBody } from "../playground/PlaygroundBody";
import type { AssignmentProgressStatus } from "../student/assignmentProgressStatus";
import type { DemoTourStep } from "./demoTourSteps";
import type { LessonRuntimeMarkDoneSpec } from "./StudentIdeBody";
import type { LessonImmersiveTheme } from "../teacher/lessonImmersiveTheme";

export interface StudentLessonAdvancedBodyProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly backTo: string;
  readonly backLabel: string;
  readonly initialFiles: readonly PlaygroundProjectFile[];
  readonly filesStorageKey: string;
  readonly tourSteps?: readonly DemoTourStep[];
  readonly lessonTestsForMarkDone?: readonly LessonRuntimeMarkDoneSpec[];
  readonly markDoneSubmissionTarget?: { cohortId: string; lessonId: string };
  readonly workspaceResetTarget?: { cohortId: string; lessonId: string };
  readonly readOnly?: boolean;
  readonly disableLocalPersist?: boolean;
  readonly assignmentProgressStatus?: AssignmentProgressStatus;
  readonly immersiveTheme?: LessonImmersiveTheme;
  readonly introMode?: "wash" | "arrive";
}

/** Advanced lesson workspace: multi-file browser with guided instructions below the editor row. */
export function StudentLessonAdvancedBody(props: StudentLessonAdvancedBodyProps) {
  return (
    <PlaygroundBody
      eyebrow={props.eyebrow}
      title={props.title}
      backTo={props.backTo}
      backLabel={props.backLabel}
      initialFiles={props.initialFiles}
      readOnly={props.readOnly}
      disableLocalPersist={props.disableLocalPersist}
      filesStorageKey={props.filesStorageKey}
      filesPanelExpanded
      tourSteps={props.tourSteps}
      lessonAssignment={
        props.lessonTestsForMarkDone !== undefined
          ? {
              lessonTestsForMarkDone: props.lessonTestsForMarkDone,
              markDoneSubmissionTarget: props.markDoneSubmissionTarget,
              assignmentProgressStatus: props.assignmentProgressStatus,
            }
          : undefined
      }
      workspaceResetTarget={props.readOnly ? undefined : props.workspaceResetTarget}
      subtitleNote={
        props.disableLocalPersist
          ? "Preview mode. Run and edit freely; nothing is saved."
          : "Advanced lesson. Use the file browser for multi-file projects. Your work saves locally in this browser."
      }
      immersiveTheme={props.immersiveTheme}
      introMode={props.introMode}
    />
  );
}
